// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://lmsapi.gvmtechnologies.net' 
    : '');

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://lmsapi.gvmtechnologies.net' 
    : '');

export { API_BASE_URL, SOCKET_URL };














